(($) => {
  $(() => {
    const $modal = $('.help-text-modal');

    if ($modal.length) {
      const $modalBody = $modal.find('.modal-body');

      $modal.on({
        'show.bs.modal': (e) => {
          const $relatedTarget = $(e.relatedTarget);
          const helpText = $relatedTarget.find('.help-text-modal__help-text').html();

          $modalBody.html(helpText);
        },
        'hide.bs.modal': () => {
          $modalBody.empty();
        },
      });
    }
  });
})(jQuery);
